import { FC } from 'react'
import { Chip } from 'src/v2/components/chip'
import chroma from 'chroma-js'
import { PARCEL_TYPES_MAP } from 'src/constants/cherre-data-dictionary/zoning-colors'
import { Hotel } from '@emotion-icons/fa-solid/Hotel'
import { Landmark } from '@emotion-icons/fa-solid/Landmark'
import { Home } from '@emotion-icons/fa-solid/Home'
import { Key } from '@emotion-icons/fa-solid/Key'
import { Industry } from '@emotion-icons/fa-solid/Industry'
import { StoreAlt } from '@emotion-icons/fa-solid/StoreAlt'
import { Building } from '@emotion-icons/fa-solid/Building'
import { Tree } from '@emotion-icons/fa-solid/Tree'
import { ExclamationTriangle } from '@emotion-icons/fa-solid/ExclamationTriangle'

type ParcelTypeChipProps = {
  type: string
  maxWidth?: number
}

export const PARCEL_TYPE_ICON_MAP = {
  commercial: Industry,
  retail: StoreAlt,
  office: Building,
  land: Tree,
  hospitality: Hotel,
  publicAmenities: Landmark,
  'single-family': Home,
  residential: Key,
  unassigned: ExclamationTriangle,
} as const

export const ParcelTypeChip: FC<ParcelTypeChipProps> = ({ type, maxWidth }) => {
  const propertyType = PARCEL_TYPES_MAP.get(type)

  if (!propertyType) {
    return null
  }

  const Icon = PARCEL_TYPE_ICON_MAP[propertyType?.id as keyof typeof PARCEL_TYPE_ICON_MAP]
  return (
    <Chip
      backgroundColor={chroma(propertyType.color).alpha(0.15).hex()}
      icon={Icon || undefined}
      iconSize={12}
      iconColor={propertyType.color}
      maxWidth={maxWidth}>
      {propertyType.label}
    </Chip>
  )
}
